module.exports = __webpack_public_path__ + "img/電気回路_4_6_1.985d5e93.png";